import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';

/**
 * The revenue a seller entered in first run. Owner rule: it lives only in
 * client state for this session (no backend, no localStorage), so a reload
 * forgets it and anything that shows it must cope with null.
 */
interface FirstRunContextValue {
  revenue: number | null;
  setRevenue: (revenue: number | null) => void;
}

const FirstRunContext = createContext<FirstRunContextValue | null>(null);

export function FirstRunProvider({ children }: { children: ReactNode }) {
  const [revenue, setRevenue] = useState<number | null>(null);
  const value = useMemo(() => ({ revenue, setRevenue }), [revenue]);
  return <FirstRunContext.Provider value={value}>{children}</FirstRunContext.Provider>;
}

export function useFirstRun(): FirstRunContextValue {
  const context = useContext(FirstRunContext);
  if (!context) {
    throw new Error('useFirstRun must be used within FirstRunProvider');
  }
  return context;
}
